export default __webpack_public_path__ + "assets/images/c0c4bd9af678c0a816a9d09bb63f219f.png";